const _ = require('lodash');
const { Honeybadger } = require('@honeybadger-io/react');
const { io, errorMessageGuard } = require('../../../../../lib/helpers/utility');
const { requestApi } = require('../../../../../api/Api');
const { showAlert } = require('components/shared/Alert/Alert');

exports.submitForm = async ({
  id,
  appointmentId,
  currentFormData,
  defaultState,
  type,
  setOverviewData,
  setCurrentHpOverviewData,
  formId = null,
  navigate,
  setSaveButtonText = () => null,
  updateSaveButton = () => null,
  user
}) => {
  try {
    if (_.isEqual(currentFormData, defaultState)) return;
    setSaveButtonText('Saving');
    const result = await requestApi({
      url: '/api/custom_form_response/create',
      params: {
        formId,
        patientId: id,
        appointmentId,
        response: currentFormData,
        type
      },
      navigate
    });

    const { code, redirect, error, newResponse } = result;
    switch (code) {
      case -1:
        navigate(redirect);
        break;
      case 0:
        this.syncHpOverviewTemplates({
          formId,
          type,
          setOverviewData,
          setCurrentHpOverviewData,
          customFormResponse: newResponse,
          user,
          patientId: id
        });
        break;
      case 2:
        error &&
          showAlert({
            title: errorMessageGuard(error),
            color: 'danger'
          });
        break;
      case 3:
        error &&
          showAlert({
            title: errorMessageGuard(error),
            color: 'danger'
          });
        break;
      default:
        Honeybadger.notify(
          `file: customFormHelper, method: submitForm - catch, error: ${
            error ? error : 'unknown error'
          }`
        );
        break;
    }
  } catch (error) {
    Honeybadger.notify(`file: customFormHelper, method: submitForm - catch, error: ${error}`);
    console.error(error);
  }
  await updateSaveButton();
};

exports.syncHpOverviewTemplates = ({
  formId,
  type,
  setOverviewData,
  setCurrentHpOverviewData,
  customFormResponse,
  user,
  patientId
}) => {
  if (!io(customFormResponse) || !setOverviewData) return;

  const customFormRows = customFormResponse?.response;

  const { f_name, l_name, id } = user;

  const createdBy = {
    id,
    fullName: `${f_name} ${l_name}`.trim(),
    isPatient: Number(patientId) === id
  };
  const customFormResponseWithCreatedInfo = { ...customFormResponse, createdBy };

  switch (type) {
    case 'medicationHistory':
      setCurrentHpOverviewData((prevState) => {
        const previousData = prevState || {};

        return {
          ...previousData,
          [type]: customFormResponse
        };
      });

      setOverviewData((prevState) => {
        const safeState = prevState || {};
        const previousTypeData = safeState[type] || [];
        const findFormId = previousTypeData?.findIndex((cForm) => cForm.id === formId);

        const allCustomForms = [...previousTypeData];
        if (findFormId >= 0) {
          allCustomForms[findFormId] = {
            ...allCustomForms[findFormId],
            createdBy,
            response: customFormRows
          };
        }

        return {
          ...safeState,
          [type]:
            findFormId >= 0
              ? allCustomForms
              : [customFormResponseWithCreatedInfo, ...(safeState.medications || [])]
        };
      });
      break;
    default:
      setCurrentHpOverviewData((prevState) => {
        const previousData = prevState || {};
        return {
          ...previousData,
          [type]: customFormResponse
        };
      });

      setOverviewData((prevState) => {
        const safeState = prevState || {};
        const previousTypeData = safeState[type] || [];
        const findFormId = previousTypeData?.findIndex((cForm) => cForm.id === formId);

        const allCustomForms = [...previousTypeData];

        if (findFormId >= 0) {
          allCustomForms[findFormId] = {
            ...allCustomForms[findFormId],
            createdBy,
            response: customFormRows
          };
        }

        return {
          ...safeState,
          [type]:
            findFormId >= 0
              ? allCustomForms
              : [customFormResponseWithCreatedInfo, ...previousTypeData]
        };
      });
      break;
  }
};

exports.scrollIntoNarrativeView = ({ ref = {}, className = '!bg-primary-50' }) => {
  setTimeout(() => {
    ref?.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    ref?.current?.classList.add(className);

    setTimeout(() => {
      ref?.current?.classList.remove(className);
    }, 3000);
  }, 500);
};

exports.convertToNormalText = (key) => {
  if (!key) return key;

  const convertedKey = key.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase();

  if (!convertedKey) return key;

  return convertedKey.charAt(0).toUpperCase() + convertedKey.slice(1).replace(/_/g, ' ');
};
